import React from "react";

import {AverageValuesSkeleton} from "../screening/sub-components/skeleton";
import AverageValues from "../shelving/sub-components/AverageValues";

const Picked = ({
                    dailyAverage,
                    weeklyAverage,
                    monthlyAverage,
                    isPickLoading,
                }) => {
    return (
        <div>
            <p className="secondHeader">Picked</p>
            {isPickLoading ? (
                <AverageValuesSkeleton/>
            ) : (
                <AverageValues
                    dailyAverage={dailyAverage}
                    weeklyAverage={weeklyAverage}
                    monthlyAverage={monthlyAverage}
                />
            )}
        </div>
    );
};

export default Picked;